/* import __COLOCATED_TEMPLATE__ from './side-navigation.hbs'; */
import Component from '@glimmer/component';
import clsx from 'clsx';

class SideNavComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      'SH-c-side-nav',
      this.args.isOpen && 'SH-c-side-nav--open',
    );
  }

  get overlayClassNames() {
    return clsx(
      'SH-c-side-nav__overlay',
      this.args.isOpen && 'SH-c-side-nav__overlay--visible',
    );
  }
}

export default SideNavComponent;
